import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import cx from 'classnames';
import React from 'react';
import { useHint } from '../../hooks';
var Hint = function Hint(props) {
  var _useHint = useHint(),
    hintRef = _useHint.hintRef,
    hintText = _useHint.hintText;
  return /*#__PURE__*/React.createElement("div", {
    className: props.className,
    style: _objectSpread({
      display: 'flex',
      flex: 1,
      height: '100%',
      position: 'relative'
    }, props.style)
  }, props.children, /*#__PURE__*/React.createElement("input", {
    "aria-hidden": true,
    className: cx('rbt-input-hint', props.hintClassName),
    ref: hintRef,
    readOnly: true,
    style: _objectSpread({
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      boxShadow: 'none',
      color: 'rgba(0, 0, 0, 0.54)',
      left: 0,
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      width: '100%'
    }, props.hintStyle),
    tabIndex: -1,
    value: hintText
  }));
};
export default Hint;